var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 135,
    viewBox: "0 0 135 135",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.5,
    cx: 67.5,
    cy: 67.5,
    r: 67.5,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0504 36.923C47.2928 36.9003 46.6641 37.5089 46.6641 38.2689V94.8307C46.6641 95.8686 47.7904 96.5176 48.6894 95.9949L97.1753 67.714C97.5894 67.4741 97.8445 67.0296 97.8419 66.5498C97.8445 66.07 97.5894 65.6255 97.1753 65.3856L48.6894 37.1048C48.4949 36.9911 48.2752 36.928 48.0505 36.9229L48.0504 36.923Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayButton);
export default __webpack_public_path__ + "static/media/playButton.1dab26cceb1cc919a9fc2055e91d40b9.svg";
export { ForwardRef as ReactComponent };